import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { TYPE } from '@/lib/typography';

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-col items-center px-s4 py-s7 text-center', className)}>
      <div
        className="mb-s4 flex h-16 w-16 items-center justify-center rounded-full bg-ds-teal-tint text-ds-teal"
        aria-hidden
      >
        {icon}
      </div>
      <h2 className={cn(TYPE.heading, 'text-ds-text')}>{title}</h2>
      {description ? (
        <p className={cn(TYPE.body, 'mt-s2 max-w-[480px] text-ds-muted')}>{description}</p>
      ) : null}
      {action ? <div className="mt-s5 w-full max-w-xs nav:w-auto">{action}</div> : null}
    </div>
  );
}
